module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "代理商",
      "label-width": "150px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.agentShow
    }
  }, [_vm._v("选择代理商")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Agent.Customer != '' || _vm.Agent.Address != '' || _vm.Agent.AgentTel != ''),
      expression: "Agent.Customer!=''||Agent.Address!=''||Agent.AgentTel!=''"
    }],
    class: {
      agent: _vm.showAgent
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v(_vm._s(_vm.Agent.AgentCode))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v(_vm._s(_vm.Agent.Customer))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v(_vm._s(_vm.Agent.Address))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v(_vm._s(_vm.Agent.AgentTel))])])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "业务员",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择或搜索"
    },
    model: {
      value: (_vm.Form.SaleEmployeeId),
      callback: function($$v) {
        _vm.$set(_vm.Form, "SaleEmployeeId", $$v)
      },
      expression: "Form.SaleEmployeeId"
    }
  }, _vm._l((_vm.EmployallData), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.value,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "label": "商品",
      "label-width": "150px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": _vm.ActionProduct
    }
  }, [_vm._v("选择商品")])], 1), _vm._v(" "), [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.PageGoodsList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "min": 1
          },
          on: {
            "change": function($event) {
              _vm.handleChangeGoods(scope.row)
            }
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.delGoods(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)]], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赠品",
      "label-width": "150px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": _vm.ActionGifts
    }
  }, [_vm._v("添加赠品")])], 1), _vm._v(" "), [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.PageGiftsList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "min": 1
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "float": "right"
          },
          on: {
            "click": function($event) {
              _vm.delGifts(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)]], 2), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.DefaultAddress.Address != undefined),
      expression: "this.DefaultAddress.Address!=undefined"
    }],
    attrs: {
      "label": "选择收货地址",
      "label-width": "150px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.DefaultAddress.Address))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "30px"
    },
    on: {
      "click": _vm.AddressShow
    }
  }, [_vm._v("更换地址")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.DefaultAddress.Consignee != undefined && this.DefaultAddress.ConsigneeTel != undefined),
      expression: "this.DefaultAddress.Consignee!=undefined&&this.DefaultAddress.ConsigneeTel!=undefined"
    }],
    attrs: {
      "label": "收货人及联系方式",
      "label-width": "150px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.DefaultAddress.Consignee))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.DefaultAddress.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.Form.SendMode),
      callback: function($$v) {
        _vm.$set(_vm.Form, "SendMode", $$v)
      },
      expression: "Form.SendMode"
    }
  }, _vm._l((_vm.transportList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.Form.PayMode),
      callback: function($$v) {
        _vm.$set(_vm.Form, "PayMode", $$v)
      },
      expression: "Form.PayMode"
    }
  }, _vm._l((_vm.PayList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注(选填)"
    },
    model: {
      value: (_vm.Form.OrderRemark),
      callback: function($$v) {
        _vm.$set(_vm.Form, "OrderRemark", $$v)
      },
      expression: "Form.OrderRemark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择代理商",
      "close-on-click-modal": false
    },
    on: {
      "close": function($event) {
        _vm.AgentSure(1)
      }
    },
    model: {
      value: (_vm.dialog.agentVisible),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "agentVisible", $$v)
      },
      expression: "dialog.agentVisible"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理商编号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请输入编号"
    },
    model: {
      value: (_vm.query.AgentId),
      callback: function($$v) {
        _vm.$set(_vm.query, "AgentId", $$v)
      },
      expression: "query.AgentId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.query.AgentName),
      callback: function($$v) {
        _vm.$set(_vm.query, "AgentName", $$v)
      },
      expression: "query.AgentName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属区域"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "选择省"
    },
    on: {
      "change": _vm.Province
    },
    model: {
      value: (_vm.query.ProvinceSelcted),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProvinceSelcted", $$v)
      },
      expression: "query.ProvinceSelcted"
    }
  }, _vm._l((_vm.ProvinceList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "选择市"
    },
    on: {
      "change": _vm.City
    },
    model: {
      value: (_vm.query.CitySelected),
      callback: function($$v) {
        _vm.$set(_vm.query, "CitySelected", $$v)
      },
      expression: "query.CitySelected"
    }
  }, _vm._l((_vm.CityList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "选择区"
    },
    model: {
      value: (_vm.query.AreaSelected),
      callback: function($$v) {
        _vm.$set(_vm.query, "AreaSelected", $$v)
      },
      expression: "query.AreaSelected"
    }
  }, _vm._l((_vm.AreaList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getAgentList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (!_vm.loading4) ? _c('div', [(_vm.AgentList.length > 0) ? _c('el-row', _vm._l((_vm.AgentList), function(item) {
    return _c('span', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "19%",
        "margin-top": "20px"
      }
    }, [_c('el-radio', {
      staticClass: "radio",
      attrs: {
        "label": item.Id
      },
      model: {
        value: (_vm.Form.AgentId),
        callback: function($$v) {
          _vm.$set(_vm.Form, "AgentId", $$v)
        },
        expression: "Form.AgentId"
      }
    }, [_vm._v(_vm._s(item.Customer))])], 1)])
  })) : _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('span', [_vm._v("暂无数据")])])], 1)], 1) : _c('div', [_c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("正在加载中....")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "50px",
      "display": "flex",
      "justify-content": "flex-end",
      "margin-bottom": "-10px"
    }
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AgentList.length > 0),
      expression: "AgentList.length>0"
    }],
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.AgentSure(2)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.DailogTile,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "close": function($event) {
        _vm.GoodsSure(1)
      }
    },
    model: {
      value: (_vm.dialog.productVisible),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "productVisible", $$v)
      },
      expression: "dialog.productVisible"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "border": "1px solid gray"
    }
  }, [_c('el-col', {
    class: {
      active: _vm.isProActive
    },
    staticStyle: {
      "height": "50px",
      "line-height": "50px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticClass: "myItem",
    on: {
      "click": _vm.activePro
    }
  }, [_vm._v("单品")])]), _vm._v(" "), _c('el-col', {
    class: {
      active: _vm.isPacActive
    },
    staticStyle: {
      "height": "50px",
      "line-height": "50px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticClass: "myItem",
    on: {
      "click": _vm.activePac
    }
  }, [_vm._v("套餐")])])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.GoodsList.length > 0),
      expression: "GoodsList.length>0"
    }],
    staticStyle: {
      "border-bottom": "1px solid gray"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('strong', [_vm._v("已选")])])], 1), _vm._v(" "), _c('el-row', _vm._l((_vm.GoodsList), function(tag) {
    return _c('el-tag', {
      staticStyle: {
        "margin": "10px 15px"
      },
      attrs: {
        "closable": true,
        "type": "gray"
      },
      on: {
        "close": function($event) {
          _vm.tagClose(tag)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(tag.ProName) + "\n                ")])
  }))], 1), _vm._v(" "), (_vm.isProActive) ? _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单品编号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入单品编号"
    },
    model: {
      value: (_vm.queryProduct.ProId),
      callback: function($$v) {
        _vm.$set(_vm.queryProduct, "ProId", $$v)
      },
      expression: "queryProduct.ProId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.queryProduct.ProName),
      callback: function($$v) {
        _vm.$set(_vm.queryProduct, "ProName", $$v)
      },
      expression: "queryProduct.ProName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flshow),
      expression: "flshow"
    }],
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "-请选择-"
    },
    on: {
      "visible-change": _vm.selChange
    },
    model: {
      value: (_vm.queryProduct.ProClass),
      callback: function($$v) {
        _vm.$set(_vm.queryProduct, "ProClass", $$v)
      },
      expression: "queryProduct.ProClass"
    }
  }, _vm._l((_vm.ProductClass), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Value,
        "label": option.Key
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "种类"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zlshow),
      expression: "zlshow"
    }],
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "-请选择-"
    },
    on: {
      "visible-change": _vm.selChange
    },
    model: {
      value: (_vm.queryProduct.ProAttr),
      callback: function($$v) {
        _vm.$set(_vm.queryProduct, "ProAttr", $$v)
      },
      expression: "queryProduct.ProAttr"
    }
  }, _vm._l((_vm.Category), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getProList
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1) : _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "套餐编号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入套餐编号"
    },
    model: {
      value: (_vm.queryPackage.ProCode),
      callback: function($$v) {
        _vm.$set(_vm.queryPackage, "ProCode", $$v)
      },
      expression: "queryPackage.ProCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.queryPackage.ProName),
      callback: function($$v) {
        _vm.$set(_vm.queryPackage, "ProName", $$v)
      },
      expression: "queryPackage.ProName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPacList
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [(!_vm.loading1) ? [_c('el-checkbox-group', {
    on: {
      "change": _vm.checkPackage
    },
    model: {
      value: (_vm.checkPacList),
      callback: function($$v) {
        _vm.checkPacList = $$v
      },
      expression: "checkPacList"
    }
  }, _vm._l((_vm.PackageList), function(item) {
    return _c('el-checkbox', {
      staticClass: "mycheckbox",
      staticStyle: {
        "width": "18%",
        "margin-top": "20px"
      },
      attrs: {
        "label": item.ProductId
      }
    }, [_vm._v(_vm._s(item.ProName))])
  }))] : [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("正在加载中......")])]], 2), _vm._v(" "), _c('el-row', [(!_vm.loading3) ? [_c('el-checkbox-group', {
    on: {
      "change": _vm.checkProduct
    },
    model: {
      value: (_vm.checkProList),
      callback: function($$v) {
        _vm.checkProList = $$v
      },
      expression: "checkProList"
    }
  }, _vm._l((_vm.ProductList), function(item) {
    return _c('el-checkbox', {
      staticClass: "mycheckbox",
      staticStyle: {
        "width": "18%",
        "margin-top": "20px"
      },
      attrs: {
        "label": item.ProductId
      }
    }, [_vm._v(_vm._s(item.ProName))])
  }))] : [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("正在加载中......")])]], 2), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "50px",
      "display": "flex",
      "justify-content": "flex-end",
      "margin-bottom": "-10px"
    }
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ProductList.length > 0),
      expression: "ProductList.length>0"
    }],
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange2
    }
  }), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PackageList.length > 0),
      expression: "PackageList.length>0"
    }],
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange3
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.GoodsSure(2)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择收货地址"
    },
    model: {
      value: (_vm.dialog.addAddressVisible),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "addAddressVisible", $$v)
      },
      expression: "dialog.addAddressVisible"
    }
  }, [_c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.AgentAddress,
      "border": ""
    },
    on: {
      "row-click": _vm.myRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Address",
      "label": "收货地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Consignee",
      "label": "收货人",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ConsigneeTel",
      "label": "联系方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsDefault",
      "label": "是否默认"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.IsDefault) ? _c('el-button', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("当前默认")]) : _c('el-button', {
          attrs: {
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.setDefaultAddress(scope.$index, scope.row)
            }
          }
        }, [_vm._v("设为默认")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "选择省"
    },
    on: {
      "change": _vm.Province
    },
    model: {
      value: (_vm.query.ProvinceSelcted),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProvinceSelcted", $$v)
      },
      expression: "query.ProvinceSelcted"
    }
  }, _vm._l((_vm.ProvinceList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "选择市"
    },
    on: {
      "change": _vm.City
    },
    model: {
      value: (_vm.query.CitySelected),
      callback: function($$v) {
        _vm.$set(_vm.query, "CitySelected", $$v)
      },
      expression: "query.CitySelected"
    }
  }, _vm._l((_vm.CityList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "选择区"
    },
    model: {
      value: (_vm.query.AreaSelected),
      callback: function($$v) {
        _vm.$set(_vm.query, "AreaSelected", $$v)
      },
      expression: "query.AreaSelected"
    }
  }, _vm._l((_vm.AreaList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.AddAddress.ConsigneeAdress),
      callback: function($$v) {
        _vm.$set(_vm.AddAddress, "ConsigneeAdress", $$v)
      },
      expression: "AddAddress.ConsigneeAdress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入联系人"
    },
    model: {
      value: (_vm.AddAddress.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.AddAddress, "Consignee", $$v)
      },
      expression: "AddAddress.Consignee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入联系方式"
    },
    model: {
      value: (_vm.AddAddress.ConsigneeTel),
      callback: function($$v) {
        _vm.$set(_vm.AddAddress, "ConsigneeTel", $$v)
      },
      expression: "AddAddress.ConsigneeTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设为默认地址"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.AddAddress.IsDefault),
      callback: function($$v) {
        _vm.$set(_vm.AddAddress, "IsDefault", $$v)
      },
      expression: "AddAddress.IsDefault"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("确认添加")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4126dbbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/addOrder.vue
// module id = 1468
// module chunks = 1